commonModule.factory('identityMgmntService', ['$http','AppSettings','userAuthenticateService', 'commonRESTCallService','$q',
    function ($http, AppSettings, userAuthenticateService, commonRESTCallService, $q) {
    var identityMgmntService = {};
    var myToken = '';

    //
    // responsible for making calls to iam.ristken.com API
    //
    var privateGetEngineeringToken = function(callback){
        var engineeringToken = '';
        if (!engineeringToken) {
            commonRESTCallService.getFromServer(
                AppSettings.startSPANPlusSvcURL + 'enchelper/imtoken'
            ).success(function (response, status, headers) {
                engineeringToken = response.TokenValue;
                callback(null,engineeringToken);
            })
            .error(function (response, status, headers, config) {
                callback(new Error(status + ' ' + response, null));
            });
        }
        else {
            callback(null,engineeringToken);
        }
    }

    identityMgmntService.getRolesAndPrivileges = function(){
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token){

            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL + 'rssapplications/application/SPAN',
                token
            ).success(function (response, status, headers) {
                deferred.resolve(response);//first user found
            })
            .error(function (response, status, headers, config) {
                deferred.reject(new Error(status + ' ' + response));
            });

        });

        return deferred.promise;
    };
    //used for Menu integration
    identityMgmntService.getUserByMenuUserName = function(menuUserName, providerCode) {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token){

            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL + 'useraccounts/legacyapp/UserMapId/' + providerCode + '_' + menuUserName,
                token
            ).
            success(function (response, status, headers) {
                deferred.resolve(response);//first user found
            })
            .error(function (response, status, headers, config) {
                deferred.reject(new Error(status + ' ' + response));
            });

        });

        return deferred.promise;
    };
    //retrieve a user by primary identifier
    identityMgmntService.getUserById = function(userId) {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token){

            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL + 'useraccounts/' + userId,
                token
            ).
            success(function (response, status, headers) {
                deferred.resolve(response);//first user found
            })
            .error(function (response, status, headers, config) {
                deferred.reject(new Error(status + ' ' + response));
            });
        });

        return deferred.promise;
    };
    //retrieve an auth token for a given dealership
    identityMgmntService.getUserSSOToken = function(imUserId) {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token) {
            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL +
                'useraccounts/ssotoken/' + imUserId + '?mins=' + AppSettings.userTokenTimeMinutes, //24 hour token
                token)
            .success(function (response, status, headers) {
                userAuthenticateService.setUserToken(response.TokenValue);
                deferred.resolve(response.TokenValue);
            })
            .error(function (response, status, headers, config) {
                deferred.reject(new Error(status + ' ' + response, null));
            });
        });

        return deferred.promise;
    };
    //retrieve the dealer by MenuPro DID
    identityMgmntService.getDealerByMenuId = function(menuDID) {
        var deferred = $q.defer();

        commonRESTCallService.getFromServerWithToken(
            AppSettings.startIdentitySvcURL + 'dealerships/legacyapp/MENUPRO/' + menuDID,
            userAuthenticateService.getUserToken()
        ).
        success(function (response, status, headers) {
            deferred.resolve(response);
        })
        .error(function (response, status, headers, config) {
            deferred.reject(status + ' ' + response);
        });

        return deferred.promise;
    };
    //retrieve a dealership by primary identifier
    identityMgmntService.getDealerById = function(dealerId) {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token) {
            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL + 'dealerships/' + dealerId,
                token)
                .success(function (response, status, headers) {
                    deferred.resolve(response);
                })
                .error(function (response, status, headers, config) {
                    deferred.reject(status + ' ' + response, null);
                });
        });

        return deferred.promise;
    };
    //retrieve a provider by provider code
    identityMgmntService.getProviderByProviderCode = function(providerCode) {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token) {
            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL + 'providers/providercode/' + providerCode,
                token)
            .success(function (response, status, headers) {
                deferred.resolve(response);
            })
            .error(function (response, status, headers, config) {
                deferred.reject(status + ' ' + response, null);
            });
        });

        return deferred.promise;
    };
    //retrieve provider by primary identifier
    identityMgmntService.getProviderByProviderId = function(providerId) {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token) {
            commonRESTCallService.getFromServerWithToken(
                AppSettings.startIdentitySvcURL + 'providers/' + providerId,
                token)
                .success(function (response, status, headers) {
                    deferred.resolve(response);
                })
                .error(function (response, status, headers, config) {
                    deferred.reject(status + ' ' + response, null);
                });
        });

        return deferred.promise;
    };
    //get the current user's provider
    identityMgmntService.getUserProvider = function() {
        var deferred = $q.defer();

        var url = AppSettings.startIdentitySvcURL + 'providers/getprovider';
        var token = userAuthenticateService.getUserToken();

        commonRESTCallService.getFromServerWithToken(url, token)
        .success(function(responseData, status) {
            // if we were to translate this to a provider model, we would do it here...
            deferred.resolve(responseData);
        }).error(function(responseData, status) {
            deferred.reject(responseData);
        });

        return deferred.promise;
    };
    //get a token for the "system" account
    identityMgmntService.getEngineeringToken = function() {
        var deferred = $q.defer();

        privateGetEngineeringToken(function(err, token) {
            if (err)
                deferred.reject(err);
            else
                deferred.resolve(token);
        });

        return deferred.promise;
    };

    return identityMgmntService;
}]);
